import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  permiteBaixarPdfBoleto: false,
};

export default rules;
